import React from "react"

function IconBriefcase({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="briefcase"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-briefcase"
      {...props}
    >
      <path
        d="M15.032 2.74c.815 0 1.441.686 1.512 1.521l.007.159-.001 1.56 4.78.001c.326 0 .596.238.646.549l.009.106v4.903c0 .261-.154.493-.386.597l-.104.037-.024.006v7.715a.655.655 0 0 1-.548.646l-.106.008H3.362A.655.655 0 0 1 2.716 20l-.008-.106v-7.715l-.024-.006a.655.655 0 0 1-.48-.524l-.01-.11V6.636c0-.326.238-.595.549-.646l.106-.009H7.76l.001-1.561c0-.853.578-1.588 1.369-1.672l.15-.008h5.752zm5.13 9.78-7.907 2.061a.655.655 0 0 1-.22.02l-.11-.02-7.909-2.06v6.717h16.146V12.52zm.514-5.23H3.504v3.743l8.585 2.239 8.587-2.239V7.29zm-8.586 2.793a1.026 1.026 0 1 1 .002 2.052 1.026 1.026 0 0 1-.002-2.052zm2.942-6.034H9.28c-.077 0-.176.105-.203.278l-.007.093v1.56h6.17l.002-1.56c0-.195-.09-.328-.17-.362l-.04-.009z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconBriefcase
